// v2.19.39-sec1 — Page /login plein écran qui réutilise AuthModal.
// À la connexion réussie, redirige vers ?next=<path> ou /.
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthModal from "@/components/AuthModal";
import { useAuth } from "@/hooks/useAuth";

export default function LoginPage() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const nextPath = (() => {
    try {
      const sp = new URLSearchParams(location.search);
      const n = sp.get("next");
      return n && n.startsWith("/") ? n : "/";
    } catch (_) {
      return "/";
    }
  })();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(nextPath, { replace: true });
    }
  }, [isAuthenticated, nextPath, navigate]);

  return (
    <div
      data-testid="login-page"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "radial-gradient(circle at 20% 20%, rgba(245,162,82,0.16), transparent 60%), radial-gradient(circle at 80% 80%, rgba(16,185,129,0.18), transparent 55%), #04180F",
        padding: "24px",
        color: "#f7f7f7",
        flexDirection: "column",
        gap: "20px",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: 480 }}>
        <div style={{ fontSize: 38, marginBottom: 8 }}>🇨🇮</div>
        <h1 style={{ fontSize: 26, fontWeight: 700, margin: "0 0 8px" }}>
          Connexion requise
        </h1>
        <p style={{ opacity: 0.8, fontSize: 14, lineHeight: 1.5, margin: 0 }}>
          Connecte-toi avec ton numéro pour accéder à AYA AI. Si le modal ne
          s&apos;affiche pas, clique sur le bouton ci-dessous.
        </p>
        <button
          data-testid="login-open-modal-btn"
          onClick={() => setOpen(true)}
          style={{
            marginTop: 18,
            padding: "12px 22px",
            background: "#f5a252",
            color: "#0b1220",
            border: "none",
            borderRadius: 12,
            fontWeight: 700,
            cursor: "pointer",
            fontSize: 15,
          }}
        >
          Ouvrir la connexion
        </button>
      </div>
      <AuthModal open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
